import { CSSProperties } from 'react'

import { usePermissions } from '@/hooks/usePermissions'

import { Box } from '@chakra-ui/react'

import { Switch } from '@/components/ui'

import { MixpanelDataIProps } from '../../shared/types/types'
import { ResolveLabelValue } from './ResolveLabelValue'

export interface IProps {
  isReal: boolean
  mixpanelData?: MixpanelDataIProps
  style?: CSSProperties
  onChange: (isReal: boolean) => void
  isLoading?: boolean
}

export const ResolveToggle = ({
  isReal,
  style,
  onChange,
  isLoading = false,
}: IProps) => {
  const { shouldEnableIncidentActions } = usePermissions()
  const isDisabled = !shouldEnableIncidentActions || isLoading

  return (
    <Box alignItems='center' display='flex' style={style}>
      <Switch
        backgroundColor='#2fb2b0'
        ballHeight='22px'
        ballPadding='4px'
        checked={isReal}
        dataTestId='incidentDrawer_resolve_setRealFalseToggle'
        disabled={isDisabled}
        height='30px'
        onChange={(e) => onChange(e.target.checked)}
        width='80px'
      />
      <ResolveLabelValue isReal={isReal} />
    </Box>
  )
}
